import { v4 as uuidv4 } from 'uuid';
import { appConfig } from './appConfig';

export default {};

export const AUTHORIZATION_TOKEN_HEADER = 'Authorization';
export const DEVICE_TYPE_ID = 'device-type-key';

const REQUEST_ID_HEADER = 'Request-ID';
const APPLICATION_ID_HEADER = 'Application-ID';
const LEGACY_REQUEST_ID_HEADER = 'RequestId';
const LEGACY_APPLICATION_ID_HEADER = 'ApplicationId';
const PROGRAM_CODE = '{programCode}';

export const parameterizeUrl = (url = '') => {
    const { programCode } = appConfig();
    const replace = url.replace(PROGRAM_CODE, programCode);

    return replace;
};

export const augmentHeaders = (options = {}, isLegacy = false) => {
    const { headers, ...rest } = options;
    const { applicationId } = appConfig();
    const defaultHeaders = {
        [isLegacy
            ? LEGACY_REQUEST_ID_HEADER
            : REQUEST_ID_HEADER]: `${uuidv4()}`,
        [isLegacy ? LEGACY_APPLICATION_ID_HEADER : APPLICATION_ID_HEADER]:
            applicationId,
        [DEVICE_TYPE_ID]: '1',
    };

    return { headers: { ...defaultHeaders, ...headers }, ...rest };
};

export const parseError = (error) => {
    const { errors = [] } = error?.errorDetails?.responseData ?? {};
    const [errorObject = {}] = errors;
    const { code: errorCode = 0, description, message, ...rest } = errorObject;

    return {
        ...rest,
        errorCode,
        statusCode: error?.errorDetails?.status ?? 0,
        message: description ?? message ?? error?.message ?? '',
        error,
    };
};
